import { render, staticRenderFns } from "./interview.vue?vue&type=template&id=180927d2&scoped=true"
import script from "./interview.vue?vue&type=script&lang=js"
export * from "./interview.vue?vue&type=script&lang=js"
import style0 from "./interview.vue?vue&type=style&index=0&id=180927d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180927d2",
  null
  
)

export default component.exports